import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Button from "components/CustomButtons/Button.js";
import Close from "@material-ui/icons/Close";
import classNames from "classnames";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";

const useStyles3 = makeStyles(javascriptStyles);

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);
Transition.displayName = "Transition";

const InformationDialog = ({
	informationDialogShow,
	setInformationDialogShow,
	selectedDialogData,
	setSelectedDialogData,
	setRequestAccessShow,
	requestAccessShow,
	requestService,
	setRequestService,
}) => {
	const classes3 = useStyles3();
	const classesCSStyles = useStylesCustomerDetailsStyles();
	return (
		<Dialog
			classes={{
				root: classes3.modalRoot,
				paper: classes3.modal,
			}}
			open={informationDialogShow}
			TransitionComponent={Transition}
			keepMounted
			onClose={() => setInformationDialogShow(false)}
			aria-labelledby="classic-modal-slide-title"
			aria-describedby="classic-modal-slide-description">
			<DialogTitle
				id="classic-modal-slide-title"
				disableTypography
				className={classNames(classes3.container, classes3.modalHeader)}>
				<Button
					simple
					className={classes3.modalCloseButton}
					key="close"
					aria-label="Close"
					onClick={() => setInformationDialogShow(false)}>
					{" "}
					<Close className={classes3.modalClose} />
				</Button>
				<h4 className={classNames(classes3.modalTitle)}>
					<img
						src={selectedDialogData.imageUrl}
						alt={selectedDialogData.Heading}
						className={classes3.modelTitleImg}
					/>
				</h4>
			</DialogTitle>
			<DialogContent
				id="classic-modal-slide-description"
				className={classes3.modalBody}>
				<hr />
				<div className={classes3.paragraphBoldModel}>{selectedDialogData.Body}</div>
				<hr />
				<div className={classes3.paragraphTitleModel}>
					<span>
						<i className="fas fa-star" />
					</span>
					Key Features:
				</div>
				<div className={classes3.paragraphModel}>
					<ul>
						{selectedDialogData.KeyFeatures.map((feature, index) => (
							<li key={index}>
								<span>
									<i className="fas fa-angle-double-right" />
								</span>
								{feature}
							</li>
						))}
					</ul>
				</div>
			</DialogContent>
			<DialogActions className={classes3.modalFooter}>
				{selectedDialogData.download != "" && (
					<a
						href={selectedDialogData.download}
						target="_blank"
						rel="noopener noreferrer">
						<button className={classesCSStyles?.buttonPrimary}>
							Download the Current Pricebook
						</button>
						{/* <Button color="info">Download the Current Pricebook</Button> */}
					</a>
				)}
				{/* <Button
					color="info"
					onClick={() => {
						setInformationDialogShow(false);
						setRequestAccessShow(true);
						setRequestService(selectedDialogData.Heading);
					}}>
					{selectedDialogData.requestAcess}
				</Button> */}
				<button
					className={classesCSStyles?.buttonPrimary}
					onClick={() => {
						setInformationDialogShow(false);
						setRequestAccessShow(true);
						setRequestService(selectedDialogData.Heading);
					}}>
					{selectedDialogData.requestAcess}
				</button>
			</DialogActions>
		</Dialog>
	);
};

export default InformationDialog;
